import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { OBJECTIVES } from '../mock';
import { useLanguage } from '../i18n/LanguageContext';

const Objectives = () => {
  const { t } = useLanguage();
  const [openSet, setOpenSet] = useState(new Set());

  const toggle = (key) => {
    setOpenSet((prev) => {
      const next = new Set(prev);
      if (next.has(key)) next.delete(key);
      else next.add(key);
      return next;
    });
  };

  return (
    <section id="objectives" className="jbss-objectives">
      <div className="jbss-container">
        <div className="jbss-objectives-head">
          <span className="jbss-eyebrow">{t('objectives.eyebrow')}</span>
          <h2 className="jbss-section-title">{t('objectives.title')}</h2>
          <p className="jbss-section-sub">{t('objectives.subtitle')}</p>
        </div>
        <div className="jbss-obj-grid jbss-obj-grid-compact">
          {OBJECTIVES.map((o, idx) => {
            const Icon = o.icon;
            const isOpen = openSet.has(o.key);
            return (
              <article
                className={`jbss-obj-card jbss-obj-card-compact ${isOpen ? 'is-open' : ''}`}
                key={o.key}
                style={{ animationDelay: `${idx * 40}ms` }}
              >
                <button
                  type="button"
                  className="jbss-obj-toggle"
                  onClick={() => toggle(o.key)}
                  aria-expanded={isOpen}
                >
                  <span className="jbss-obj-icon"><Icon size={18} /></span>
                  <span className="jbss-obj-title">{t(`objectives.items.${o.key}.title`)}</span>
                  <span className="jbss-obj-chevron"><ChevronDown size={16} /></span>
                </button>
                <div className="jbss-obj-collapse">
                  <div className="jbss-obj-collapse-inner">
                    <p className="jbss-obj-desc">{t(`objectives.items.${o.key}.desc`)}</p>
                  </div>
                </div>
                <div className="jbss-obj-underline" />
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Objectives;
